import { useUpdateDatasetInfo } from 'api/api-hooks/datasets-hooks';
import { BaseDatasetDTO } from 'api/model/dataset/BaseDatasetDTO';
import { GroupButtonProps } from 'api/model/dataset/datasetGroups'
import { easasAlert } from 'components/fragments/easas-global-fragment/EasasGlobalAlerts';
import { Button } from 'primereact/button';
import React from 'react'
import { T } from 'services/lang/LanguageService';

type SetGroupButtonProps = GroupButtonProps & {
  selectedDatasets: BaseDatasetDTO[];
  closeDialog: () => void;
};

const SetGroupButton: React.FC<SetGroupButtonProps> = ({
  group,
  selectedDatasets,
  closeDialog,
}) => {
  const { mutateAsync } = useUpdateDatasetInfo();

  const handleSetGroup = async () => {
    const results = await Promise.allSettled(
      selectedDatasets.map(async dataset => {
        return mutateAsync({ ...dataset, groupId: group?.id! });
      })
    );

    const successFullMutations = results.filter(result => result.status === "fulfilled");
    const failedMutations = results.filter(result => result.status === "rejected");

    if (successFullMutations.length === results.length) {
      easasAlert({
        summary: T("alert.success"),
        detail: T("alert.all-changes-were-saved-successfully"),
        severity: "success",
      });
    } else {
      easasAlert({
        summary: T("alert.error"),
        detail: T("error.datasets-failed-to-update", {count: failedMutations.length}),
        severity: "error",
      });
    }
    closeDialog();
  };

  return (
    <div className='flex align-items-center gap-3'>
      <Button label={T("action.set-group")} icon="pi pi-check" className='component-editor-button icon-blue' onClick={handleSetGroup} />
      <p>{T("message.count-datasets-will-be-affected", {count: selectedDatasets.length})}</p>
    </div>
  );
};

export default SetGroupButton